<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                :isRequiredFarms="false"
                :isRequiredLots="false"
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
                classFarms="col-12 col-sm-6 col-md-6 col-lg-4"
                classLots="col-12 col-sm-6 col-md-6 col-lg-4"
              >
                <template slot="prev">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4 pt-3">
                    <label for="">{{ $t('common_words.evaluations') }}: </label>
                    <br />
                    <el-select
                      @clear="clearDataWhenEvaluation()"
                      @change="
                        selectAllFromSelect('evaluationsSel', evaluations)
                      "
                      clearable
                      collapse-tags
                      style="width: 100%"
                      multiple
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      v-model="evaluationsSel"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        class="select-primary selected-all"
                        v-for="item in evaluations"
                        :key="`${item.id}-${item.name}`"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </card>
        <card v-if="tableData">
          <el-container>
            <el-aside width="18%" style="overflow-x: hidden">
              <el-menu :default-openeds="['0']">
                <el-submenu index="0">
                  <template slot="title"
                    ><em class="el-icon-document"></em
                    >{{ $t('common_words.evaluations') }}</template
                  >
                  <el-menu-item-group class="custom-el-menu-item-group-cal">
                    <el-menu-item
                      @click="handleChangeMenuSelected(label, i)"
                      v-for="(label, i) in getLabelInspections"
                      :key="`${label}-${i}`"
                      v-bind:index="`${label}-${i}`"
                      style="min-width: 140px"
                      class="custom-el-menu-item-cal"
                    >
                      <abbreviated-text-tooltip :text="label" />
                    </el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-aside>
            <el-container>
              <el-main>
                <div class="row">
                  <div class="col-12">
                    <el-collapse
                      class="custom-el-collapse"
                      v-model="farmActiveName"
                      accordion
                    >
                      <el-collapse-item
                        class="custom-collapse-item"
                        v-for="(farm, i) in farmData"
                        :name="`${i}`"
                        :key="`${farm}-${i}`"
                      >
                        <template slot="title">
                          <span style="text-transform: capitalize">
                            <strong>{{ $t('common_words.farm') }}: </strong>
                            {{ farm }}
                          </span>
                        </template>
                        <div class="row">
                          <div
                            class="col-12 mb-4"
                            style="overflow-x: auto"
                            v-for="(subCategory, j) in tableData[menuSelected][
                              farm
                            ]"
                            :key="`${i}-${j}`"
                          >
                            <div
                              class="table-responsive"
                              v-if="subCategory['Objetiva']"
                            >
                              <table
                                class="el-table table-striped table-bordered mt-4"
                                aria-describedby="table-subcategory"
                                style="min-width: max-content"
                              >
                                <thead class="cusmtom-thead-color">
                                  <tr>
                                    <th
                                      class="p-3"
                                      scope="row"
                                      v-bind:colspan="
                                        1 +
                                        getDateColumn(subCategory, 'Objetiva')
                                          .length *
                                          2
                                      "
                                    >
                                      {{ j }} (Objetiva)
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      class="p-3"
                                      scope="col"
                                      rowspan="2"
                                      style="width: 300px"
                                    >
                                      {{ $t('common_words.task_or_activity') }}
                                    </th>
                                    <th
                                      scope="col"
                                      colspan="2"
                                      style="width: 140px"
                                      class="text-center p-2"
                                      v-for="date in getDateColumn(
                                        subCategory,
                                        'Objetiva'
                                      )"
                                      :key="date"
                                    >
                                      {{ date }} <br />
                                      ({{ $t('common_words.grade') }})
                                    </th>
                                  </tr>
                                  <tr>
                                    <template
                                      v-for="date in getDateColumn(
                                        subCategory,
                                        'Objetiva'
                                      )"
                                    >
                                      <th
                                        scope="col"
                                        style="
                                          background-color: #20a857 !important;
                                          width: 70px;
                                        "
                                        class="text-center p-2"
                                      >
                                        {{ $t('common_words.yes') }}
                                      </th>
                                      <th
                                        scope="col"
                                        style="
                                          background-color: #ff4c4c !important;
                                          width: 70px;
                                        "
                                        class="text-center p-2"
                                      >
                                        {{ $t('common_words.no') }}
                                      </th>
                                    </template>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(task, k) in subCategory['Objetiva']"
                                    :key="k"
                                  >
                                    <td class="p-2">{{ k }}</td>
                                    <template
                                      v-for="iDataDateTask in getDateColumn(
                                        subCategory,
                                        'Objetiva'
                                      )"
                                    >
                                      <td
                                        class="text-center p-2"
                                        v-if="task[iDataDateTask]"
                                      >
                                        <template
                                          v-for="(taskDate, index) in task[
                                            iDataDateTask
                                          ]"
                                        >
                                          <p
                                            class="my-0"
                                            v-if="taskDate['value_objective']"
                                          >
                                            {{
                                              taskDate['value_objective']['Si']
                                                ? 1
                                                : 0
                                            }}
                                          </p>
                                          <p class="my-0" v-else>0</p>
                                          <hr
                                            v-if="
                                              Object.values(task[iDataDateTask])
                                                .length > 1 &&
                                              index <
                                                Object.values(
                                                  task[iDataDateTask]
                                                ).length -
                                                  1
                                            "
                                          />
                                        </template>
                                      </td>
                                      <td class="text-center p-2" v-else>0</td>
                                      <td
                                        class="text-center p-2"
                                        v-if="task[iDataDateTask]"
                                      >
                                        <template
                                          v-for="(taskDate, index) in task[
                                            iDataDateTask
                                          ]"
                                        >
                                          <p
                                            class="my-0"
                                            v-if="taskDate['value_objective']"
                                          >
                                            {{
                                              taskDate['value_objective']['No']
                                                ? 1
                                                : 0
                                            }}
                                          </p>
                                          <p class="my-0" v-else>0</p>
                                          <hr
                                            v-if="
                                              Object.values(task[iDataDateTask])
                                                .length > 1 &&
                                              index <
                                                Object.values(
                                                  task[iDataDateTask]
                                                ).length -
                                                  1
                                            "
                                          />
                                        </template>
                                      </td>
                                      <td class="text-center p-2" v-else>0</td>
                                    </template>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td class="p-3">
                                      <strong style="font-size: 16px">{{
                                        $t('common_words.totalized')
                                      }}</strong>
                                    </td>
                                    <template
                                      v-for="date in getDateColumn(
                                        subCategory,
                                        'Objetiva'
                                      )"
                                    >
                                      <td class="text-center p-2">
                                        <strong style="font-size: 16px">{{
                                          getCountYesAnswer(
                                            statistic[menuSelected][farm][j][
                                              date
                                            ]['Objetiva']
                                          ).length
                                        }}</strong>
                                      </td>
                                      <td class="text-center p-2">
                                        <strong style="font-size: 16px">{{
                                          getCountNotAnswer(
                                            statistic[menuSelected][farm][j][
                                              date
                                            ]['Objetiva']
                                          ).length
                                        }}</strong>
                                      </td>
                                    </template>
                                  </tr>
                                  <tr>
                                    <td class="p-3">
                                      <strong style="font-size: 16px">{{
                                        $t('common_words.mayus_accomplishment')
                                      }}</strong>
                                    </td>
                                    <td
                                      colspan="2"
                                      class="text-center p-2"
                                      v-for="date in getDateColumn(
                                        subCategory,
                                        'Objetiva'
                                      )"
                                      :key="date"
                                    >
                                      <strong style="font-size: 16px"
                                        >{{
                                          getTotalCompliance(
                                            statistic[menuSelected][farm][j][
                                              date
                                            ]['Objetiva']
                                          )
                                        }}%</strong
                                      >
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                          <div
                            class="col-12 mb-4"
                            style="overflow-x: auto"
                            v-for="(subCategory, l) in tableData[menuSelected][
                              farm
                            ]"
                            :key="`${l}`"
                          >
                            <div
                              class="table-responsive"
                              v-if="subCategory['Subjetiva']"
                            >
                              <table
                                class="el-table table-striped table-bordered mt-4"
                                aria-describedby="table-subcategory"
                                style="min-width: max-content"
                              >
                                <thead class="cusmtom-thead-color">
                                  <tr>
                                    <th
                                      class="p-3"
                                      scope="row"
                                      v-bind:colspan="
                                        1 +
                                        getDateColumn(subCategory, 'Subjetiva')
                                          .length *
                                          2
                                      "
                                    >
                                      {{ l }} ({{
                                        $t('common_words.subjective_fem')
                                      }})
                                    </th>
                                  </tr>
                                  <tr>
                                    <th
                                      class="p-3"
                                      scope="col"
                                      style="width: 300px"
                                    >
                                      {{ $t('common_words.task_or_activity') }}
                                    </th>
                                    <th
                                      scope="col"
                                      style="width: 140px"
                                      class="text-center p-2"
                                      v-for="date in getDateColumn(
                                        subCategory,
                                        'Subjetiva'
                                      )"
                                      :key="date"
                                    >
                                      {{ date }} <br />
                                      ({{ $t('common_words.grade') }})
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(task, m) in subCategory[
                                      'Subjetiva'
                                    ]"
                                    :key="m"
                                  >
                                    <td class="p-2">{{ m }}</td>
                                    <template
                                      v-for="iDataDateTask in getDateColumn(
                                        subCategory,
                                        'Subjetiva'
                                      )"
                                    >
                                      <td
                                        :class="`text-center ${
                                          len(task[iDataDateTask]) ? '' : 'p-2'
                                        }`"
                                        v-if="task[iDataDateTask]"
                                        :style="
                                          len(task[iDataDateTask])
                                            ? ''
                                            : handlecellstyle(
                                                task[iDataDateTask]
                                              )
                                        "
                                      >
                                        <template
                                          v-for="(taskDate, index) in task[
                                            iDataDateTask
                                          ]"
                                        >
                                          <p
                                            v-if="taskDate['answer']"
                                            :style="
                                              handlecellstyle(
                                                null,
                                                taskDate['answer']
                                              )
                                            "
                                            class="my-0 multiple-cell"
                                          >
                                            {{ taskDate['answer'] }}
                                          </p>
                                          <p
                                            :style="handlecellstyle(null, 0)"
                                            class="my-0 multiple-cell"
                                            v-else
                                          >
                                            0
                                          </p>
                                          <hr
                                            class="mt-0 mb-0"
                                            v-if="
                                              Object.values(task[iDataDateTask])
                                                .length > 1 &&
                                              index <
                                                Object.values(
                                                  task[iDataDateTask]
                                                ).length -
                                                  1
                                            "
                                          />
                                        </template>
                                      </td>
                                      <td
                                        :style="handlecellstyle(null, 0)"
                                        class="text-center p-2"
                                        v-else
                                      >
                                        0
                                      </td>
                                    </template>
                                  </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td class="p-3">
                                      <strong style="font-size: 16px">{{
                                        $t('common_words.mayus_average')
                                      }}</strong>
                                    </td>
                                    <td
                                      class="text-center p-2"
                                      v-for="date in getDateColumn(
                                        subCategory,
                                        'Subjetiva'
                                      )"
                                      :key="date"
                                      :style="
                                        handlecellstyle(
                                          null,
                                          getTotalAVG(
                                            statistic[menuSelected][farm][l][
                                              date
                                            ]['Subjetiva']
                                          )
                                        )
                                      "
                                    >
                                      <strong style="font-size: 16px">{{
                                        getTotalAVG(
                                          statistic[menuSelected][farm][l][
                                            date
                                          ]['Subjetiva']
                                        )
                                      }}</strong>
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </el-main>
            </el-container>
          </el-container>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import Filter from 'src/components/Filter/Filters.vue';
import AbbreviatedTextTooltip from 'src/components/Texts/AbbreviatedTextTooltip.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [AbbreviatedTextTooltip.name]: AbbreviatedTextTooltip,
    [Filter.name]: Filter,
  },

  computed: {
    getLabelInspections() {
      return Object.keys(this.tableData).sort();
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      activeName: 'filter',
      farmActiveName: '0',
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        evaluations: [],
        farm: [],
        lot: [],
      },
      evaluations: [],
      evaluationsSel: [],
      menuSelected: null,
      tableData: null,
      dateColumn: null,
      statistic: null,
      valueCollapse: null,
      farmData: [],
    };
  },

  mixins: [
    MixinExport,
    MixinMasters,
    MixinMenu,
    MixinNotification,
    MixinPermissions,
  ],
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.evaluations = this.concatAll(this.evaluations.splice(1));
    },

    len(task) {
      return task.length > 0;
    },

    clearDataWhenEvaluation() {
      this.evaluationsSel = null;
      this.tableData = null;
    },

    getCountYesAnswer(data) {
      return data.filter((value) => value === 1);
    },

    getCountNotAnswer(data) {
      return data.filter((value) => value === 0 || value === null);
    },

    getTotalAVG(data) {
      return parseFloat(
        data.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0) / data.length
      ).toFixed(2);
    },

    getTotalCompliance(data) {
      return parseFloat(
        (data.filter((value) => value === 1).length / data.length) * 100
      ).toFixed(2);
    },

    getDateColumn(subCategory, type) {
      const dates = [];
      Object.values(subCategory[type]).forEach((task) => {
        this.dateColumn[type].forEach((date) => {
          if (task[date] && !dates.includes(date)) dates.push(date);
        });
      });

      return dates.sort((a, b) => b - a).reverse();
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleChangeMenuSelected(label) {
      this.showHideLoading(true);
      this.menuSelected = label;
      this.farmData = Object.keys(this.tableData[label]);

      try {
        document
          .getElementsByClassName('el-menu-item custom-el-menu-item-cal')[0]
          .classList.remove('is-active');

        let obj = event.path[0];
        obj.classList.add('is-active');
        setTimeout(() => {
          this.showHideLoading();
        }, 20);
      } catch (error) {
        this.showHideLoading();
      }
    },

    handlecellstyle(tasks, value = null) {
      const answer = value || Number(value) === 0 ? value : tasks[0]['answer'];
      if (Number(answer) >= 0 && Number(answer) <= 6) {
        return 'background-color: #ff4c4c !important; color: white !important';
      }
      if (Number(answer) >= 7 && Number(answer) <= 8) {
        return 'background-color: #FEDB39 !important; color: black !important';
      }
      if (Number(answer) >= 9 && Number(answer) <= 10) {
        return 'background-color: #20a857 !important; color: white !important';
      }
      if (Number(answer) == 11) {
        return 'background-color: #9d9d9d !important; color: white !important';
      }

      return '';
    },

    handleFilter(data) {
      this.dataFilter = { ...data };
      this.tableData = null;
      this.farmData = [];
      this.getDataSamplingReport();
    },

    getDataSamplingReport() {
      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'quality/inspections/samplingreport';
      data.evaluations = this.evaluationsSel;
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.table;
          this.statistic = response.data.statistic;
          this.dateColumn = response.data.dateColumn;
          if (this.tableData.length == 0) {
            SweetAlert.warning('No hay datos disponibles');
            this.tableData = null;
            this.showHideLoading();
          } else {
            setTimeout(() => {
              const keysTable = Object.keys(this.tableData).sort();
              this.handleChangeMenuSelected(keysTable[0]);
              document
                .getElementsByClassName(
                  'el-menu-item custom-el-menu-item-cal'
                )[0]
                .classList.add('is-active');
              this.showHideLoading();
            }, 100);
          }
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      Axios.getMasters('quality/quality/inspections').then((response) => {
        this.evaluations = this.concatAll(response.data.data);
      });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  destroyed() {
    this.deselectedItemOnMenu('quality');
  },
};
</script>
<style>
.multiple-cell {
  width: 100%;
  height: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
